export default __webpack_public_path__ + "static/media/linkedIn.7defd339.svg";